// utils/departmentConfig.js - COMPLETE WITH FIXES AND DEBUG FUNCTIONS

// FIXED: Generate proper API parameters for agencies
const generateAgencyApiParams = (tableName, agencyName) => {
  const encodedAgency = encodeURIComponent(agencyName);
  // FIXED: Use proper parameter names that match the API and URL generation
  const result = `&skip=0&schema=united_states_of_america&table=${tableName}&order_by=created_at&filter_column=agency&filter_string=${encodedAgency}`;
  // console.log(`generateAgencyApiParams: ${agencyName} -> ${result}`);
  return result;
};

export const departmentConfig = {

  whitehouse: {
    departmentInfo: {
      name: 'White House',
      image: '/whiteHouse.png',
      missionStatement: 'The White House serves as the home and office of the President of the United States.',
      officialURL: 'https://www.whitehouse.gov',
      route: '/us/whitehouse'
    },
    mainFeeds: [
      {
        id: 'whitehouseBriefing',
        name: 'Briefing Room',
        apiParams: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: ''
      },
      {
        id: 'presidentialActions',
        name: 'Presidential Actions',
        apiParams: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at&filter_column=category&filter_string=Presidential%20Actions',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document'
      },
      {
        id: 'presidentialDocuments',
        name: 'Presidential Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=compilation_of_presidential_documents&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Doc'
      },
      {
        id: 'presidentialProclamations',
        name: 'Presidential Proclamations',
        apiParams: '&skip=0&schema=united_states_of_america&table=presidential_proclamation&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document'
      }
    ],
    agencies: []
  },
  state: {
    departmentInfo: {
      name: 'Department of State',
      image: '/departmentOfState.png',
      officialURL: 'https://www.state.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-1/pdf/STATUTE-1-Pg28.pdf',
      missionStatement: 'Create a more secure, democratic, and prosperous world for the benefit of the American people and the international community.',
      establishingActText: 'An Act to provide for the organization of the Government of the United States...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there shall be an executive department, to be denominated the Department of Foreign Affairs, and that there shall be a principal officer therein, to be called the Secretary for the Department of Foreign Affairs...`,
      route: '/us/departmentofstate',
      urlKey: 'departmentofstate'
  },
    
    mainFeeds: [
      {
        id: 'stateDepartment',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=state&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      },
      {
        id: 'stateDocs',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=state&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20State%20Documents',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main',
      }
    ],
    
    agencies: [

    ]
  },

  treasury: {
    departmentInfo: {
      name: 'Department of the Treasury',
      image: '/departmentOfTreasury.png',
      officialURL: 'https://www.treasury.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-1/pdf/STATUTE-1-Pg65.pdf',
      missionStatement: 'Maintain a strong economy and create economic and job opportunities by promoting the conditions that enable economic growth and stability at home and abroad, strengthen national security by combating threats and protecting the integrity of the financial system, and manage the U.S. Government\'s finances and resources effectively.',
      establishingActText: 'An Act to establish the Treasury Department...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there shall be a Department of Treasury, in which shall be the following officers, namely: a Secretary of the Treasury...`,
      route: '/us/departmentoftreasury',
      urlKey: 'departmentoftreasury'
    },
    mainFeeds: [
      {
        id: 'treasuryDepartment',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=treasury&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'Economy',
        buttonName: '',
        type: 'main'
      },
      {
        id: 'treasuryDocs',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=treasury&order_by=created_at&filter_column=agency&filter_string=Treasury%20Department',
        feedBranch: 'Executive',
        feedTopic: 'Economy',
        buttonName: '',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'alcohol-tobacco',
        name: 'Alcohol and Tobacco Tax and Trade Bureau',
        shortName: 'TTB',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/alcohol-tobacco',
        officialURL: 'https://www.ttb.gov/',
        missionStatement: 'TTB protects consumers and the revenue by ensuring that alcohol beverages are produced, labeled, advertised, and marketed in accordance with Federal laws and regulations.',
        apiParams: generateAgencyApiParams('treasury', 'Alcohol and Tobacco Tax and Trade Bureau'),
        feedName: 'Alcohol and Tobacco Tax and Trade Bureau Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Tax & Revenue'
      },
      {
        id: 'fiscal-service',
        name: 'Bureau of the Fiscal Service',
        shortName: 'BFS',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/fiscal-service',
        officialURL: 'https://www.fiscal.treasury.gov/',
        missionStatement: 'BFS promotes the financial integrity and operational efficiency of the federal government through exceptional accounting, financing, collections, payments, and shared services.',
        apiParams: generateAgencyApiParams('treasury', 'Bureau of the Fiscal Service'),
        feedName: 'Bureau of the Fiscal Service Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Financial Services'
      },
      {
        id: 'cdfi',
        name: 'Community Development Financial Institutions Fund',
        shortName: 'CDFI Fund',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/cdfi',
        officialURL: 'https://www.cdfifund.gov/',
        missionStatement: 'The CDFI Fund promotes economic revitalization and community development through investment in and assistance to community development financial institutions.',
        apiParams: generateAgencyApiParams('treasury', 'Community Development Financial Institutions Fund'),
        feedName: 'Community Development Financial Institutions Fund Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Community Development'
      },
      {
        id: 'comptroller-currency',
        name: 'Office of the Comptroller of the Currency',
        shortName: 'OCC',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/comptroller-currency',
        officialURL: 'https://www.occ.gov/',
        missionStatement: 'The OCC charters, regulates, and supervises all national banks and federal savings associations as well as federal branches and agencies of foreign banks.',
        apiParams: generateAgencyApiParams('treasury', 'Comptroller of the Currency'),
        feedName: 'Office of the Comptroller of the Currency Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Banking Regulation'
      },
      {
        id: 'engraving-printing',
        name: 'Bureau of Engraving and Printing',
        shortName: 'BEP',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/engraving-printing',
        officialURL: 'https://www.bep.gov/',
        missionStatement: 'BEP designs and manufactures U.S. paper currency, securities, and other official certificates and awards.',
        apiParams: generateAgencyApiParams('treasury', 'Engraving and Printing Bureau'),
        feedName: 'Bureau of Engraving and Printing Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Currency Production'
      },
      {
        id: 'fincen',
        name: 'Financial Crimes Enforcement Network',
        shortName: 'FinCEN',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/fincen',
        officialURL: 'https://www.fincen.gov/',
        missionStatement: 'FinCEN safeguards the financial system from illicit use and combats money laundering and promotes national security through the collection, analysis, and dissemination of financial intelligence.',
        apiParams: generateAgencyApiParams('treasury', 'Financial Crimes Enforcement Network'),
        feedName: 'Financial Crimes Enforcement Network Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Financial Intelligence'
      },
      {
        id: 'ofac',
        name: 'Office of Foreign Assets Control',
        shortName: 'OFAC',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/ofac',
        officialURL: 'https://www.treasury.gov/ofac',
        missionStatement: 'OFAC administers and enforces economic and trade sanctions based on US foreign policy and national security goals.',
        apiParams: generateAgencyApiParams('treasury', 'Foreign Assets Control Office'),
        feedName: 'Office of Foreign Assets Control Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Sanctions & Trade'
      },
      {
        id: 'irs',
        name: 'Internal Revenue Service',
        shortName: 'IRS',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/irs',
        officialURL: 'https://www.irs.gov/',
        missionStatement: 'The IRS is responsible for collecting taxes and administering the Internal Revenue Code, the main body of federal statutory tax law.',
        apiParams: generateAgencyApiParams('treasury', 'Internal Revenue Service'),
        feedName: 'Internal Revenue Service Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Tax Administration'
      },
      {
        id: 'us-mint',
        name: 'United States Mint',
        shortName: 'US Mint',
        image: '/departmentOfTreasury.png',
        route: '/us/departmentoftreasury/us-mint',
        officialURL: 'https://www.usmint.gov/',
        missionStatement: 'The United States Mint produces circulating coinage for the nation to conduct its trade and commerce, as well as controlling the movement of bullion.',
        apiParams: generateAgencyApiParams('treasury', 'United States Mint'),
        feedName: 'United States Mint Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Currency Production'
      }
    ]
  },

  justice: {
    departmentInfo: {
      name: 'Department of Justice',
      image: '/departmentOfJustice.png',
      officialURL: 'https://www.justice.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-4/pdf/STATUTE-4-Pg366.pdf',
      missionStatement: 'To enforce the law and defend the interests of the United States according to the law; to ensure public safety against threats foreign and domestic; to provide federal leadership in preventing and controlling crime; to seek just punishment for those guilty of unlawful behavior; and to ensure fair and impartial administration of justice for all Americans.',
      establishingActText: 'An Act to establish the Department of Justice...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there shall be, and is hereby established, an executive department of the government of the United States, to be called the Department of Justice...`,
      route: '/us/departmentofjustice',
      urlKey: 'departmentofjustice'
    },
    mainFeeds: [
      {
        id: 'justiceNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=justice&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      },
      {
        id: 'frDefense',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=justice&order_by=created_at&filter_column=agency&filter_string=Justice%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Documents',
        type: 'main'
      },
      {
        id: 'defAd',
        name: 'Antitrust Division',
        apiParams: '&table_name=justice&agency=Antitrust%20Division',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defDea',
        name: 'Drug Enforcement Administration',
        apiParams: '&table_name=justice&agency=Drug%20Enforcement%20Administration',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defFbi',
        name: 'Federal Bureau of Investigation',
        apiParams: '&table_name=justice&agency=Federal%20Bureau%20of%20Investigation',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defFpi',
        name: 'Federal Prison Industries',
        apiParams: '&table_name=justice&agency=Federal%20Prison%20Industries',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defFcsc',
        name: 'Foreign Claims Settlement Commission',
        apiParams: '&table_name=justice&agency=Foreign%20Claims%20Settlement%20Commission',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defJpo',
        name: 'Office of Justice Programs',
        apiParams: '&table_name=justice&agency=Justice%20Programs%20Office',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defJjdpo',
        name: 'Office of Juvenile Justice',
        apiParams: '&table_name=justice&agency=Juvenile%20Justice%20and%20Delinquency%20Prevention%20Office',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defNic',
        name: 'National Institute of Corrections',
        apiParams: '&table_name=justice&agency=National%20Institute%20of%20Corrections',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defNij',
        name: 'National Institute of Justice',
        apiParams: '&table_name=justice&agency=National%20Institute%20of%20Justice',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defPc',
        name: 'U.S. Parole Commission',
        apiParams: '&table_name=justice&agency=Parole%20Commission',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      },
      {
        id: 'defUsms',
        name: 'U.S. Marshals Service',
        apiParams: '&table_name=justice&agency=United%20States%20Marshals%20Service',
        feedBranch: 'Executive',
        feedTopic: 'Justice',
        buttonName: 'Doc',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'antitrust',
        name: 'Antitrust Division',
        shortName: 'Antitrust',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/antitrust',
        officialURL: 'https://www.justice.gov/atr',
        missionStatement: 'The Antitrust Division promotes economic competition through enforcing and providing guidance on antitrust laws and principles.',
        apiParams: generateAgencyApiParams('justice', 'Antitrust Division'),
        feedName: 'Antitrust Division Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Legal & Regulatory'
      },
      {
        id: 'dea',
        name: 'Drug Enforcement Administration',
        shortName: 'DEA',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/dea',
        officialURL: 'https://www.dea.gov/',
        missionStatement: 'DEA enforces the controlled substances laws and regulations of the United States and brings to the criminal and civil justice system those organizations and principal members involved in the growing, manufacture, or distribution of controlled substances.',
        apiParams: generateAgencyApiParams('justice', 'Drug Enforcement Administration'),
        feedName: 'Drug Enforcement Administration Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Law Enforcement'
      },
      {
        id: 'fbi',
        name: 'Federal Bureau of Investigation',
        shortName: 'FBI',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/fbi',
        officialURL: 'https://www.fbi.gov/',
        missionStatement: 'The FBI protects the American people and upholds the Constitution of the United States.',
        apiParams: generateAgencyApiParams('justice', 'Federal Bureau of Investigation'),
        feedName: 'Federal Bureau of Investigation Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Law Enforcement'
      },
      {
        id: 'federal-prison-industries',
        name: 'Federal Prison Industries',
        shortName: 'FPI',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/federal-prison-industries',
        officialURL: 'https://www.unicor.gov/',
        missionStatement: 'FPI provides job skills training for inmates confined in Federal correctional facilities through a diversified portfolio of manufacturing and service operations.',
        apiParams: generateAgencyApiParams('justice', 'Federal Prison Industries'),
        feedName: 'Federal Prison Industries Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Corrections'
      },
      {
        id: 'foreign-claims',
        name: 'Foreign Claims Settlement Commission',
        shortName: 'FCSC',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/foreign-claims',
        officialURL: 'https://www.justice.gov/fcsc',
        missionStatement: 'The FCSC determines the validity and amounts of claims by U.S. nationals against foreign governments for losses and injuries sustained by them.',
        apiParams: generateAgencyApiParams('justice', 'Foreign Claims Settlement Commission'),
        feedName: 'Foreign Claims Settlement Commission Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Claims & Settlements'
      },
      {
        id: 'justice-programs',
        name: 'Office of Justice Programs',
        shortName: 'OJP',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/justice-programs',
        officialURL: 'https://www.ojp.gov/',
        missionStatement: 'OJP provides federal leadership in developing the nation\'s capacity to prevent and control crime, improve the criminal and juvenile justice systems, increase knowledge about crime and related issues, and assist crime victims.',
        apiParams: generateAgencyApiParams('justice', 'Justice Programs Office'),
        feedName: 'Office of Justice Programs Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Justice Programs'
      },
      {
        id: 'juvenile-justice',
        name: 'Office of Juvenile Justice and Delinquency Prevention',
        shortName: 'OJJDP',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/juvenile-justice',
        officialURL: 'https://www.ojjdp.gov/',
        missionStatement: 'OJJDP provides national leadership, coordination, and resources to prevent and respond to juvenile delinquency and victimization.',
        apiParams: generateAgencyApiParams('justice', 'Juvenile Justice and Delinquency Prevention Office'),
        feedName: 'Office of Juvenile Justice and Delinquency Prevention Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Juvenile Justice'
      },
      {
        id: 'national-institute-corrections',
        name: 'National Institute of Corrections',
        shortName: 'NIC',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/national-institute-corrections',
        officialURL: 'https://nicic.gov/',
        missionStatement: 'NIC provides training, technical assistance, information services, and policy/program development assistance to federal, state, and local corrections agencies.',
        apiParams: generateAgencyApiParams('justice', 'National Institute of Corrections'),
        feedName: 'National Institute of Corrections Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Corrections'
      },
      {
        id: 'national-institute-justice',
        name: 'National Institute of Justice',
        shortName: 'NIJ',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/national-institute-justice',
        officialURL: 'https://nij.ojp.gov/',
        missionStatement: 'NIJ is the research, development and evaluation agency of the U.S. Department of Justice and is dedicated to improving knowledge and understanding of crime and justice issues through science.',
        apiParams: generateAgencyApiParams('justice', 'National Institute of Justice'),
        feedName: 'National Institute of Justice Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'parole-commission',
        name: 'U.S. Parole Commission',
        shortName: 'USPC',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/parole-commission',
        officialURL: 'https://www.justice.gov/uspc',
        missionStatement: 'The U.S. Parole Commission makes parole release decisions for eligible federal and D.C. Code offenders and revocation decisions for those released on parole or supervised release.',
        apiParams: generateAgencyApiParams('justice', 'Parole Commission'),
        feedName: 'U.S. Parole Commission Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Parole & Release'
      },
      {
        id: 'marshals-service',
        name: 'United States Marshals Service',
        shortName: 'USMS',
        image: '/departmentOfJustice.png',
        route: '/us/departmentofjustice/marshals-service',
        officialURL: 'https://www.usmarshals.gov/',
        missionStatement: 'The U.S. Marshals Service is the nation\'s oldest and most versatile federal law enforcement agency.',
        apiParams: generateAgencyApiParams('justice', 'United States Marshals Service'),
        feedName: 'United States Marshals Service Documents',
        topic: 'Justice',
        buttonName: 'Document',
        category: 'Law Enforcement'
      }
    ]
  },
  transportation: {
    departmentInfo: {
      name: 'Department of Transportation',
      image: '/departmentOfTransportation.png',
      officialURL: 'https://www.transportation.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-80/pdf/STATUTE-80-Pg931.pdf',
      missionStatement: 'Ensure our Nation has the safest, most efficient and modern transportation system in the world, which boosts our economic productivity and global competitiveness and enhances the quality of life in communities both rural and urban.',
      establishingActText: 'An Act to establish a Department of Transportation...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there is hereby established at the seat of the Government of the United States an executive department to be known as the Department of Transportation...`,
      route: '/us/departmentoftransportation',
      urlKey: 'departmentoftransportation'
    },
    mainFeeds: [
      {
        id: 'transDepartment',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=transportation&order_by=created_at&filter_column=agency&filter_string=Transportation%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: '',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'commercial-space-transportation',
        name: 'Office of Commercial Space Transportation',
        shortName: 'AST',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/commercial-space-transportation',
        officialURL: 'https://www.faa.gov/about/office_org/headquarters_offices/ast',
        missionStatement: 'AST regulates commercial space transportation to protect the public, property, and the national security and foreign policy interests of the United States.',
        apiParams: generateAgencyApiParams('transportation', 'Commercial Space Transportation Office'),
        feedName: 'Office of Commercial Space Transportation Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Space Transportation'
      },
      {
        id: 'faa',
        name: 'Federal Aviation Administration',
        shortName: 'FAA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/faa',
        officialURL: 'https://www.faa.gov/',
        missionStatement: 'FAA regulates civil aviation to promote safety and provide the most efficient aerospace system in the world.',
        apiParams: generateAgencyApiParams('transportation', 'Federal Aviation Administration'),
        feedName: 'Federal Aviation Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Aviation'
      },
      {
        id: 'fhwa',
        name: 'Federal Highway Administration',
        shortName: 'FHWA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/fhwa',
        officialURL: 'https://www.fhwa.dot.gov/',
        missionStatement: 'FHWA provides stewardship over the construction, maintenance and preservation of the Nation\'s highways, bridges and tunnels.',
        apiParams: generateAgencyApiParams('transportation', 'Federal Highway Administration'),
        feedName: 'Federal Highway Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Highways'
      },
      {
        id: 'fmcsa',
        name: 'Federal Motor Carrier Safety Administration',
        shortName: 'FMCSA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/fmcsa',
        officialURL: 'https://www.fmcsa.dot.gov/',
        missionStatement: 'FMCSA prevents commercial motor vehicle-related fatalities and injuries.',
        apiParams: generateAgencyApiParams('transportation', 'Federal Motor Carrier Safety Administration'),
        feedName: 'Federal Motor Carrier Safety Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Motor Carrier Safety'
      },
      {
        id: 'fra',
        name: 'Federal Railroad Administration',
        shortName: 'FRA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/fra',
        officialURL: 'https://www.fra.dot.gov/',
        missionStatement: 'FRA promulgates and enforces rail safety regulations; administers rail funding; conducts research and development in support of improved railroad safety and national rail transportation policy.',
        apiParams: generateAgencyApiParams('transportation', 'Federal Railroad Administration'),
        feedName: 'Federal Railroad Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Railroad'
      },
      {
        id: 'fta',
        name: 'Federal Transit Administration',
        shortName: 'FTA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/fta',
        officialURL: 'https://www.transit.dot.gov/',
        missionStatement: 'FTA provides financial and technical assistance to local public transit systems.',
        apiParams: generateAgencyApiParams('transportation', 'Federal Transit Administration'),
        feedName: 'Federal Transit Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Transit'
      },
      {
        id: 'great-lakes-seaway',
        name: 'Great Lakes St. Lawrence Seaway Development Corporation',
        shortName: 'GLS',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/great-lakes-seaway',
        officialURL: 'https://www.seaway.dot.gov/',
        missionStatement: 'The Great Lakes St. Lawrence Seaway Development Corporation operates and maintains the U.S. portion of the St. Lawrence Seaway.',
        apiParams: generateAgencyApiParams('transportation', 'Great Lakes St. Lawrence Seaway Development Corporation'),
        feedName: 'Great Lakes St. Lawrence Seaway Development Corporation Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Maritime'
      },
      {
        id: 'maritime',
        name: 'Maritime Administration',
        shortName: 'MARAD',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/maritime',
        officialURL: 'https://www.maritime.dot.gov/',
        missionStatement: 'MARAD promotes the use of waterborne transportation and its seamless integration with other segments of the transportation system.',
        apiParams: generateAgencyApiParams('transportation', 'Maritime Administration'),
        feedName: 'Maritime Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Maritime'
      },
      {
        id: 'nhtsa',
        name: 'National Highway Traffic Safety Administration',
        shortName: 'NHTSA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/nhtsa',
        officialURL: 'https://www.nhtsa.gov/',
        missionStatement: 'NHTSA saves lives, prevents injuries and reduces economic costs due to road traffic crashes.',
        apiParams: generateAgencyApiParams('transportation', 'National Highway Traffic Safety Administration'),
        feedName: 'National Highway Traffic Safety Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Traffic Safety'
      },
      {
        id: 'motor-carrier-safety',
        name: 'Office of Motor Carrier Safety',
        shortName: 'OMCS',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/motor-carrier-safety',
        officialURL: 'https://www.fmcsa.dot.gov/',
        missionStatement: 'The Office of Motor Carrier Safety ensures the safety of commercial motor vehicles.',
        apiParams: generateAgencyApiParams('transportation', 'Office of Motor Carrier Safety'),
        feedName: 'Office of Motor Carrier Safety Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Motor Carrier Safety'
      },
      {
        id: 'phmsa',
        name: 'Pipeline and Hazardous Materials Safety Administration',
        shortName: 'PHMSA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/phmsa',
        officialURL: 'https://www.phmsa.dot.gov/',
        missionStatement: 'PHMSA protects people and the environment by advancing the safe transportation of energy and other hazardous materials.',
        apiParams: generateAgencyApiParams('transportation', 'Pipeline and Hazardous Materials Safety Administration'),
        feedName: 'Pipeline and Hazardous Materials Safety Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Pipeline Safety'
      },
      {
        id: 'research-innovative-technology',
        name: 'Research and Innovative Technology Administration',
        shortName: 'RITA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/research-innovative-technology',
        officialURL: 'https://www.transportation.gov/',
        missionStatement: 'RITA coordinates the Department\'s research and development programs and activities.',
        apiParams: generateAgencyApiParams('transportation', 'Research and Innovative Technology Administration'),
        feedName: 'Research and Innovative Technology Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'research-special-programs',
        name: 'Research and Special Programs Administration',
        shortName: 'RSPA',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/research-special-programs',
        officialURL: 'https://www.transportation.gov/',
        missionStatement: 'RSPA coordinates research and special transportation programs.',
        apiParams: generateAgencyApiParams('transportation', 'Research and Special Programs Administration'),
        feedName: 'Research and Special Programs Administration Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'transportation-statistics',
        name: 'Bureau of Transportation Statistics',
        shortName: 'BTS',
        image: '/departmentOfTransportation.png',
        route: '/us/departmentoftransportation/transportation-statistics',
        officialURL: 'https://www.bts.gov/',
        missionStatement: 'BTS creates, manages, and shares transportation statistical knowledge with public and private transportation communities and the nation.',
        apiParams: generateAgencyApiParams('transportation', 'Transportation Statistics Bureau'),
        feedName: 'Bureau of Transportation Statistics Documents',
        topic: 'Infrastructure',
        buttonName: 'Document',
        category: 'Statistics & Data'
      }
    ]
  },
  agriculture: {
    departmentInfo: {
      name: 'Department of Agriculture',
      image: '/departmentOfAgriculture.svg',
      officialURL: 'https://www.usda.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-23/pdf/STATUTE-23-Pg31.pdf',
      missionStatement: 'We provide leadership on food, agriculture, natural resources, rural development, nutrition, and related issues based on public policy, the best available science, and effective management.',
      establishingActText: 'An Act to establish a Department of Agriculture...',
      fullEstablishingAct: `SEC. 1. There is hereby established at the seat of Government a Department of Agriculture, the general designs and duties of which shall be to acquire and to diffuse among the people of the United States useful information on subjects connected with agriculture in the most general and comprehensive sense of that word, and to procure, propagate, and distribute among the people new and valuable seeds and plants.`,
      route: '/us/departmentofagriculture',
      urlKey: 'departmentofagriculture'
    },
    mainFeeds: [
      {
        id: 'agricultureNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=environment&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'Environment',
        buttonName: '',
        type: 'main'
      },
      {
        id: 'agricultureDocs',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=environment&order_by=created_at&filter_column=agency&filter_string=Department%20of%20Agriculture',
        feedBranch: 'Executive',
        feedtopic: 'Environment',
        buttonName: '',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'advocacy',
        name: 'Advocacy and Outreach Office',
        shortName: 'Advocacy Office',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/advocacy',
        officialURL: 'http://www.outreach.usda.gov/index.htm',
        missionStatement: 'We provide leadership on food, agriculture, natural resources, rural development, nutrition, and related issues based on public policy, the best available science, and effective management.',
        apiParams: generateAgencyApiParams('environment', 'Advocacy and Outreach Office'),
        feedName: 'Advocacy and Outreach Office Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Administrative & Support'
      },
      {
        id: 'agricultural-marketing',
        name: 'Agricultural Marketing Service',
        shortName: 'AMS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/agricultural-marketing',
        officialURL: 'https://www.ams.usda.gov/',
        missionStatement: 'AMS facilitates the marketing of U.S. agricultural products including food, fiber, and specialty crops.',
        apiParams: generateAgencyApiParams('environment', 'Agricultural Marketing Service'),
        feedName: 'Agricultural Marketing Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Marketing & Trade'
      },
      {
        id: 'agricultural-research',
        name: 'Agricultural Research Service',
        shortName: 'ARS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/agricultural-research',
        officialURL: 'https://www.ars.usda.gov/',
        missionStatement: 'ARS conducts research to develop and transfer solutions to agricultural problems of high national priority.',
        apiParams: generateAgencyApiParams('environment', 'Agricultural Research Service'),
        feedName: 'Agricultural Research Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'animal-plant-health',
        name: 'Animal and Plant Health Inspection Service',
        shortName: 'APHIS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/animal-plant-health',
        officialURL: 'https://www.aphis.usda.gov/',
        missionStatement: 'APHIS protects the health and value of American agriculture and natural resources.',
        apiParams: generateAgencyApiParams('environment', 'Animal and Plant Health Inspection Service'),
        feedName: 'Animal and Plant Health Inspection Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Regulatory & Inspection'
      },
      {
        id: 'commodity-credit',
        name: 'Commodity Credit Corporation',
        shortName: 'CCC',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/commodity-credit',
        officialURL: 'https://www.fsa.usda.gov/about-fsa/structure-and-organization/commodity-credit-corporation/index',
        missionStatement: 'CCC supports the production and marketing of agricultural commodities.',
        apiParams: generateAgencyApiParams('environment', 'Commodity Credit Corporation'),
        feedName: 'Commodity Credit Corporation Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Farm Programs'
      },
      {
        id: 'cooperative-state-research',
        name: 'Cooperative State Research, Education, and Extension Service',
        shortName: 'CSREES',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/cooperative-state-research',
        officialURL: 'https://nifa.usda.gov/about-nifa',
        missionStatement: 'CSREES advances agriculture-related sciences through research, education, and extension.',
        apiParams: generateAgencyApiParams('environment', 'Cooperative State Research, Education, and Extension Service'),
        feedName: 'Cooperative State Research, Education, and Extension Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'economic-analysis',
        name: 'Economic Analysis Staff',
        shortName: 'EAS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/economic-analysis',
        officialURL: 'https://www.usda.gov/oce',
        missionStatement: 'The Economic Analysis Staff provides economic analysis and data to support USDA\'s missions.',
        apiParams: generateAgencyApiParams('environment', 'Economic Analysis Staff'),
        feedName: 'Economic Analysis Staff Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'economic-research',
        name: 'Economic Research Service',
        shortName: 'ERS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/economic-research',
        officialURL: 'https://www.ers.usda.gov/',
        missionStatement: 'ERS anticipates trends and emerging issues in agriculture, food, the environment, and rural America and conducts high-quality, objective economic research.',
        apiParams: generateAgencyApiParams('environment', 'Economic Research Service'),
        feedName: 'Economic Research Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'farm-service',
        name: 'Farm Service Agency',
        shortName: 'FSA',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/farm-service',
        officialURL: 'https://www.fsa.usda.gov/',
        missionStatement: 'FSA equitably serves all farmers, ranchers, and agricultural partners through the delivery of effective, efficient agricultural programs for all Americans.',
        apiParams: generateAgencyApiParams('environment', 'Farm Service Agency'),
        feedName: 'Farm Service Agency Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Farm Programs'
      },
      {
        id: 'federal-crop-insurance',
        name: 'Federal Crop Insurance Corporation',
        shortName: 'FCIC',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/federal-crop-insurance',
        officialURL: 'https://www.rma.usda.gov/',
        missionStatement: 'FCIC provides crop insurance to American farmers and ranchers.',
        apiParams: generateAgencyApiParams('environment', 'Federal Crop Insurance Corporation'),
        feedName: 'Federal Crop Insurance Corporation Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Farm Programs'
      },
      {
        id: 'food-consumer-service',
        name: 'Food and Consumer Service',
        shortName: 'FCS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/food-consumer-service',
        officialURL: 'https://www.fns.usda.gov/',
        missionStatement: 'FCS administers the nation\'s domestic nutrition assistance programs including WIC, SNAP, and school meals.',
        apiParams: generateAgencyApiParams('environment', 'Food and Consumer Service'),
        feedName: 'Food and Consumer Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Nutrition Programs'
      },
      {
        id: 'food-nutrition-service',
        name: 'Food and Nutrition Service',
        shortName: 'FNS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/food-nutrition-service',
        officialURL: 'https://www.fns.usda.gov/',
        missionStatement: 'FNS increases food security and reduces hunger by providing children and low-income people access to food, a healthful diet, and nutrition education.',
        apiParams: generateAgencyApiParams('environment', 'Food and Nutrition Service'),
        feedName: 'Food and Nutrition Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Nutrition Programs'
      },
      {
        id: 'food-safety-inspection',
        name: 'Food Safety and Inspection Service',
        shortName: 'FSIS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/food-safety-inspection',
        officialURL: 'https://www.fsis.usda.gov/',
        missionStatement: 'FSIS protects the public\'s health by ensuring the safety of meat, poultry, and processed egg products.',
        apiParams: generateAgencyApiParams('environment', 'Food Safety and Inspection Service'),
        feedName: 'Food Safety and Inspection Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Regulatory & Inspection'
      },
      {
        id: 'foreign-agricultural',
        name: 'Foreign Agricultural Service',
        shortName: 'FAS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/foreign-agricultural',
        officialURL: 'https://www.fas.usda.gov/',
        missionStatement: 'FAS links U.S. agriculture to the world to enhance export opportunities and global food security.',
        apiParams: generateAgencyApiParams('environment', 'Foreign Agricultural Service'),
        feedName: 'Foreign Agricultural Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Marketing & Trade'
      },
      {
        id: 'forest-service',
        name: 'Forest Service',
        shortName: 'FS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/forest-service',
        officialURL: 'https://www.fs.usda.gov/',
        missionStatement: 'The Forest Service sustains the health, diversity, and productivity of the nation\'s forests and grasslands.',
        apiParams: generateAgencyApiParams('environment', 'Forest Service'),
        feedName: 'Forest Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Natural Resources'
      },
      {
        id: 'national-agricultural-library',
        name: 'National Agricultural Library',
        shortName: 'NAL',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/national-agricultural-library',
        officialURL: 'https://www.nal.usda.gov/',
        missionStatement: 'NAL provides access to agricultural information and serves as a gateway to the world\'s agricultural information and knowledge for USDA and the public.',
        apiParams: generateAgencyApiParams('environment', 'National Agricultural Library'),
        feedName: 'National Agricultural Library Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'national-agricultural-statistics',
        name: 'National Agricultural Statistics Service',
        shortName: 'NASS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/national-agricultural-statistics',
        officialURL: 'https://www.nass.usda.gov/',
        missionStatement: 'NASS provides timely, accurate, and useful statistics in service to U.S. agriculture.',
        apiParams: generateAgencyApiParams('environment', 'National Agricultural Statistics Service'),
        feedName: 'National Agricultural Statistics Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'nifa',
        name: 'National Institute of Food and Agriculture',
        shortName: 'NIFA',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/nifa',
        officialURL: 'https://nifa.usda.gov/',
        missionStatement: 'NIFA provides leadership and funding for programs that advance agriculture-related sciences.',
        apiParams: generateAgencyApiParams('environment', 'National Institute of Food and Agriculture'),
        feedName: 'National Institute of Food and Agriculture Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Research & Development'
      },
      {
        id: 'natural-resources-conservation',
        name: 'Natural Resources Conservation Service',
        shortName: 'NRCS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/natural-resources-conservation',
        officialURL: 'https://www.nrcs.usda.gov/',
        missionStatement: 'NRCS provides America\'s farmers and ranchers with financial and technical assistance to voluntarily put conservation on the ground, not only helping the environment but agricultural operations too.',
        apiParams: generateAgencyApiParams('environment', 'Natural Resources Conservation Service'),
        feedName: 'Natural Resources Conservation Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Conservation'
      },
      {
        id: 'operations-office',
        name: 'Operations Office',
        shortName: 'Operations',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/operations-office',
        officialURL: 'https://www.usda.gov/our-agency/about-usda',
        missionStatement: 'The Operations Office oversees the administrative functions within the USDA.',
        apiParams: generateAgencyApiParams('environment', 'Operations Office'),
        feedName: 'Operations Office Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Administrative & Support'
      },
      {
        id: 'partnerships-public-engagement',
        name: 'Partnerships and Public Engagement Office',
        shortName: 'OPPE',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/partnerships-public-engagement',
        officialURL: 'https://www.usda.gov/partnerships',
        missionStatement: 'The Office of Partnerships and Public Engagement connects USDA with rural and underserved communities to ensure equal access to USDA programs and services.',
        apiParams: generateAgencyApiParams('environment', 'Partnerships and Public Engagement Office'),
        feedName: 'Partnerships and Public Engagement Office Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Administrative & Support'
      },
      {
        id: 'procurement-property-management',
        name: 'Procurement and Property Management, Office of',
        shortName: 'OPPM',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/procurement-property-management',
        officialURL: 'https://www.dm.usda.gov/procurement/',
        missionStatement: 'The Office of Procurement and Property Management provides procurement and property management services to USDA agencies and offices.',
        apiParams: generateAgencyApiParams('environment', 'Procurement and Property Management, Office of'),
        feedName: 'Procurement and Property Management Office Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Administrative & Support'
      },
      {
        id: 'risk-management',
        name: 'Risk Management Agency',
        shortName: 'RMA',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/risk-management',
        officialURL: 'https://www.rma.usda.gov/',
        missionStatement: 'RMA helps producers manage their business risks through effective, market-based risk management solutions.',
        apiParams: generateAgencyApiParams('environment', 'Risk Management Agency'),
        feedName: 'Risk Management Agency Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Farm Programs'
      },
      {
        id: 'rural-business-cooperative',
        name: 'Rural Business-Cooperative Service',
        shortName: 'RBS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/rural-business-cooperative',
        officialURL: 'https://www.rd.usda.gov/about-rd/agencies/rural-business-cooperative-service',
        missionStatement: 'RBS offers programs to help businesses grow as well as job training for people living in rural areas.',
        apiParams: generateAgencyApiParams('environment', 'Rural Business-Cooperative Service'),
        feedName: 'Rural Business-Cooperative Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Rural Programs'
      },
      {
        id: 'rural-housing-community-development',
        name: 'Rural Housing and Community Development Service',
        shortName: 'RHCDS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/rural-housing-community-development',
        officialURL: 'https://www.rd.usda.gov/programs-services/all-programs/housing-and-community-facilities-programs',
        missionStatement: 'RHCDS provides financing for housing, community facilities, and infrastructure in rural areas.',
        apiParams: generateAgencyApiParams('environment', 'Rural Housing and Community Development Service'),
        feedName: 'Rural Housing and Community Development Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Rural Programs'
      },
      {
        id: 'rural-housing',
        name: 'Rural Housing Service',
        shortName: 'RHS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/rural-housing',
        officialURL: 'https://www.rd.usda.gov/about-rd/agencies/rural-housing-service',
        missionStatement: 'RHS offers a variety of programs to build or improve housing and essential community facilities in rural areas.',
        apiParams: generateAgencyApiParams('environment', 'Rural Housing Service'),
        feedName: 'Rural Housing Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Rural Programs'
      },
      {
        id: 'rural-telephone-bank',
        name: 'Rural Telephone Bank',
        shortName: 'RTB',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/rural-telephone-bank',
        officialURL: 'https://www.rd.usda.gov/programs-services/rural-utilities-service',
        missionStatement: 'The Rural Telephone Bank provides financial assistance for the improvement of telecommunications services in rural areas.',
        apiParams: generateAgencyApiParams('environment', 'Rural Telephone Bank'),
        feedName: 'Rural Telephone Bank Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Rural Programs'
      },
      {
        id: 'rural-utilities',
        name: 'Rural Utilities Service',
        shortName: 'RUS',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/rural-utilities',
        officialURL: 'https://www.rd.usda.gov/about-rd/agencies/rural-utilities-service',
        missionStatement: 'RUS provides infrastructure or infrastructure improvements to rural communities, including water and waste treatment, electric power, and telecommunications services.',
        apiParams: generateAgencyApiParams('environment', 'Rural Utilities Service'),
        feedName: 'Rural Utilities Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Rural Programs'
      },
      {
        id: 'transportation-office',
        name: 'Transportation Office',
        shortName: 'TO',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/transportation-office',
        officialURL: 'https://www.ams.usda.gov/services/transportation',
        missionStatement: 'The Transportation Office supports the agricultural transportation system to ensure efficient and cost-effective movement of goods.',
        apiParams: generateAgencyApiParams('environment', 'Transportation Office'),
        feedName: 'Transportation Office Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Administrative & Support'
      },
      {
        id: 'us-codex-office',
        name: 'U.S. Codex Office',
        shortName: 'Codex',
        image: '/departmentOfAgriculture.svg',
        route: '/us/departmentofagriculture/us-codex-office',
        officialURL: 'https://www.usda.gov/codex',
        missionStatement: 'The U.S. Codex Office leads U.S. participation in the Codex Alimentarius Commission, which sets international food standards to protect consumer health and ensure fair practices in food trade.',
        apiParams: generateAgencyApiParams('environment', 'U.S. Codex Office'),
        feedName: 'U.S. Codex Office Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Regulatory & Inspection'
      }
    ]
  },

  interior: {
    departmentInfo: {
      name: 'Department of the Interior',
      image: '/departmentOfInterior.png',
      officialURL: 'https://www.doi.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-9/pdf/STATUTE-9-Pg395.pdf',
      missionStatement: 'The Department of the Interior protects and manages the Nation\'s natural resources and cultural heritage; provides scientific and other information about those resources and natural hazards; and honors its trust responsibilities or special commitments to American Indians, Alaska Natives, and affiliated island communities.',
      establishingActText: 'An Act to establish the Home Department...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there be established at the seat of government of the United States a department to be called the Department of the Interior...`,
      route: '/us/departmentoftheinterior',
      urlKey: 'departmentoftheinterior'
    },
    mainFeeds: [
      {
        id: 'theInteriorDepartment',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=interior&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      },
      {
        id: 'frDefense',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=interior&order_by=created_at&filter_column=agency&filter_string=Interior%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'fish-wildlife',
        name: 'U.S. Fish and Wildlife Service',
        shortName: 'FWS',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/fish-wildlife',
        officialURL: 'https://www.fws.gov/',
        missionStatement: 'The U.S. Fish and Wildlife Service works with others to conserve, protect, and enhance fish, wildlife, plants, and their habitats for the continuing benefit of the American people.',
        apiParams: generateAgencyApiParams('interior', 'Fish and Wildlife Service'),
        feedName: 'U.S. Fish and Wildlife Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Wildlife Conservation'
      },
      {
        id: 'geological-survey',
        name: 'U.S. Geological Survey',
        shortName: 'USGS',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/geological-survey',
        officialURL: 'https://www.usgs.gov/',
        missionStatement: 'USGS is a science organization that provides impartial information on the health of our ecosystems and environment, the natural hazards that threaten us, the water, energy, and mineral resources we rely on.',
        apiParams: generateAgencyApiParams('interior', 'Geological Survey'),
        feedName: 'U.S. Geological Survey Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Earth Sciences'
      },
      {
        id: 'indian-affairs',
        name: 'Bureau of Indian Affairs',
        shortName: 'BIA',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/indian-affairs',
        officialURL: 'https://www.bia.gov/',
        missionStatement: 'The Bureau of Indian Affairs provides services directly or through contracts, grants, or compacts to federally recognized tribes.',
        apiParams: generateAgencyApiParams('interior', 'Indian Affairs Bureau'),
        feedName: 'Bureau of Indian Affairs Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Native American Affairs'
      },
      {
        id: 'land-management',
        name: 'Bureau of Land Management',
        shortName: 'BLM',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/land-management',
        officialURL: 'https://www.blm.gov/',
        missionStatement: 'BLM manages public lands for multiple use and sustained yield of renewable and nonrenewable resources.',
        apiParams: generateAgencyApiParams('interior', 'Land Management Bureau'),
        feedName: 'Bureau of Land Management Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Land Management'
      },
      {
        id: 'national-park-service',
        name: 'National Park Service',
        shortName: 'NPS',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/national-park-service',
        officialURL: 'https://www.nps.gov/',
        missionStatement: 'The National Park Service preserves unimpaired the natural and cultural resources and values of the National Park System for the enjoyment, education, and inspiration of this and future generations.',
        apiParams: generateAgencyApiParams('interior', 'National Park Service'),
        feedName: 'National Park Service Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Parks & Recreation'
      },
      {
        id: 'reclamation',
        name: 'Bureau of Reclamation',
        shortName: 'Reclamation',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/reclamation',
        officialURL: 'https://www.usbr.gov/',
        missionStatement: 'The Bureau of Reclamation manages, develops, and protects water and related resources in an environmentally and economically sound manner.',
        apiParams: generateAgencyApiParams('interior', 'Reclamation Bureau'),
        feedName: 'Bureau of Reclamation Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Water Resources'
      },
      {
        id: 'ocean-energy-management',
        name: 'Bureau of Ocean Energy Management',
        shortName: 'BOEM',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/ocean-energy-management',
        officialURL: 'https://www.boem.gov/',
        missionStatement: 'BOEM promotes energy independence, environmental protection, and economic development through responsible, science-based management of offshore conventional and renewable energy.',
        apiParams: generateAgencyApiParams('interior', 'Ocean Energy Management Bureau'),
        feedName: 'Bureau of Ocean Energy Management Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Energy Management'
      },
      {
        id: 'safety-environmental-enforcement',
        name: 'Bureau of Safety and Environmental Enforcement',
        shortName: 'BSEE',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/safety-environmental-enforcement',
        officialURL: 'https://www.bsee.gov/',
        missionStatement: 'BSEE promotes safety, protects the environment, and conserves resources offshore through vigorous regulatory oversight and enforcement.',
        apiParams: generateAgencyApiParams('interior', 'Safety and Environmental Enforcement Bureau'),
        feedName: 'Bureau of Safety and Environmental Enforcement Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Safety & Enforcement'
      },
      {
        id: 'surface-mining',
        name: 'Office of Surface Mining Reclamation and Enforcement',
        shortName: 'OSMRE',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/surface-mining',
        officialURL: 'https://www.osmre.gov/',
        missionStatement: 'OSMRE carries out the requirements of the Surface Mining Control and Reclamation Act in partnership with states and tribes.',
        apiParams: generateAgencyApiParams('interior', 'Surface Mining Reclamation and Enforcement Office'),
        feedName: 'Office of Surface Mining Reclamation and Enforcement Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Mining Regulation'
      },
      {
        id: 'indian-gaming',
        name: 'National Indian Gaming Commission',
        shortName: 'NIGC',
        image: '/departmentOfInterior.png',
        route: '/us/departmentoftheinterior/indian-gaming',
        officialURL: 'https://www.nigc.gov/',
        missionStatement: 'NIGC regulates gaming activities on Indian lands for the purpose of shielding Indian tribes from organized crime and other corrupting influences.',
        apiParams: generateAgencyApiParams('interior', 'National Indian Gaming Commission'),
        feedName: 'National Indian Gaming Commission Documents',
        topic: 'Environment',
        buttonName: 'Document',
        category: 'Gaming Regulation'
      }
    ]
  },
  labor: {
    departmentInfo: {
      name: 'Department of Labor',
      image: '/departmentOfLabor.png',
      officialURL: 'https://www.dol.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-37/pdf/STATUTE-37-Pg736.pdf',
      missionStatement: 'To foster, promote, and develop the welfare of the wage earners, job seekers, and retirees of the United States; improve working conditions; advance opportunities for profitable employment; and assure work-related benefits and rights.',
      establishingActText: 'An Act to create a Department of Labor...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there shall be at the seat of government a department of Labor, the general design and duties of which shall be to acquire and diffuse among the people of the United States useful information on subjects connected with labor...`,
      route: '/us/departmentoflabor',
      urlKey: 'departmentoflabor'
    },
    mainFeeds: [
      {
        id: 'laborDocuments',
        name: 'Department of Labor Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=labor&order_by=created_at&filter_column=agency&filter_string=Labor%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'disability-employment-policy',
        name: 'Office of Disability Employment Policy',
        shortName: 'ODEP',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/disability-employment-policy',
        officialURL: 'https://www.dol.gov/agencies/odep',
        missionStatement: 'ODEP provides national leadership to increase employment opportunities for adults and youth with disabilities.',
        apiParams: generateAgencyApiParams('labor', 'Disability Employment Policy Office'),
        feedName: 'Office of Disability Employment Policy Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Employment Policy'
      },
      {
        id: 'ebsa',
        name: 'Employee Benefits Security Administration',
        shortName: 'EBSA',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/ebsa',
        officialURL: 'https://www.dol.gov/agencies/ebsa',
        missionStatement: 'EBSA assists workers in getting the information they need to exercise their benefit rights and meets its obligation to enforce the law.',
        apiParams: generateAgencyApiParams('labor', 'Employee Benefits Security Administration'),
        feedName: 'Employee Benefits Security Administration Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Employee Benefits'
      },
      {
        id: 'employees-compensation-appeals',
        name: 'Employees\' Compensation Appeals Board',
        shortName: 'ECAB',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/employees-compensation-appeals',
        officialURL: 'https://www.dol.gov/agencies/ecab',
        missionStatement: 'ECAB hears and decides appeals from determinations and awards with respect to claims of federal employees who sustained work-related injuries.',
        apiParams: generateAgencyApiParams('labor', 'Employees Compensation Appeals Board'),
        feedName: 'Employees\' Compensation Appeals Board Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Workers\' Compensation'
      },
      {
        id: 'eta',
        name: 'Employment and Training Administration',
        shortName: 'ETA',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/eta',
        officialURL: 'https://www.dol.gov/agencies/eta',
        missionStatement: 'ETA provides training, employment, labor market information, and income maintenance services.',
        apiParams: generateAgencyApiParams('labor', 'Employment and Training Administration'),
        feedName: 'Employment and Training Administration Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Employment & Training'
      },
      {
        id: 'employment-standards',
        name: 'Employment Standards Administration',
        shortName: 'ESA',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/employment-standards',
        officialURL: 'https://www.dol.gov/',
        missionStatement: 'ESA administers and enforces statutes which require contractors on government construction projects and federally assisted projects to pay prevailing wages.',
        apiParams: generateAgencyApiParams('labor', 'Employment Standards Administration'),
        feedName: 'Employment Standards Administration Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Employment Standards'
      },
      {
        id: 'federal-contract-compliance',
        name: 'Office of Federal Contract Compliance Programs',
        shortName: 'OFCCP',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/federal-contract-compliance',
        officialURL: 'https://www.dol.gov/agencies/ofccp',
        missionStatement: 'OFCCP enforces, for the benefit of job seekers and wage earners, the contractual promise of affirmative action and equal employment opportunity.',
        apiParams: generateAgencyApiParams('labor', 'Federal Contract Compliance Programs Office'),
        feedName: 'Office of Federal Contract Compliance Programs Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Equal Employment'
      },
      {
        id: 'labor-statistics',
        name: 'Bureau of Labor Statistics',
        shortName: 'BLS',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/labor-statistics',
        officialURL: 'https://www.bls.gov/',
        missionStatement: 'BLS measures labor market activity, working conditions, price changes, and productivity in the U.S. economy.',
        apiParams: generateAgencyApiParams('labor', 'Labor Statistics Bureau'),
        feedName: 'Bureau of Labor Statistics Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Labor Statistics'
      },
      {
        id: 'msha',
        name: 'Mine Safety and Health Administration',
        shortName: 'MSHA',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/msha',
        officialURL: 'https://www.msha.gov/',
        missionStatement: 'MSHA works to prevent death, disease, and injury from mining and promote safe and healthful workplaces for miners.',
        apiParams: generateAgencyApiParams('labor', 'Mine Safety and Health Administration'),
        feedName: 'Mine Safety and Health Administration Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Mine Safety'
      },
      {
        id: 'veterans-employment',
        name: 'Veterans\' Employment and Training Service',
        shortName: 'VETS',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/veterans-employment',
        officialURL: 'https://www.dol.gov/agencies/vets',
        missionStatement: 'VETS provides resources and expertise to assist and prepare veterans to obtain meaningful careers, maximize their employment opportunities, and protect their employment rights.',
        apiParams: generateAgencyApiParams('labor', 'Veterans Employment and Training Service'),
        feedName: 'Veterans\' Employment and Training Service Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Veterans Employment'
      },
      {
        id: 'wage-hour',
        name: 'Wage and Hour Division',
        shortName: 'WHD',
        image: '/departmentOfLabor.png',
        route: '/us/departmentoflabor/wage-hour',
        officialURL: 'https://www.dol.gov/agencies/whd',
        missionStatement: 'WHD enforces federal minimum wage, overtime pay, recordkeeping, and child labor requirements.',
        apiParams: generateAgencyApiParams('labor', 'Wage and Hour Division'),
        feedName: 'Wage and Hour Division Documents',
        topic: 'Economy',
        buttonName: 'Document',
        category: 'Wage & Hour Standards'
      }
    ]
  },
  defense: {
    departmentInfo: {
      name: 'Department of Defense',
      image: '/departmentOfDefense.png',
      officialURL: 'https://www.defense.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-1/pdf/STATUTE-1-Pg49-2.pdf',
      missionStatement: 'The Department of Defense provides the military forces needed to deter war and ensure our nation\'s security.',
      establishingActText: 'Be it enacted by the Senate and House of Representatives...',
      fullEstablishingAct: `Section 1. Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there shall be an executive department to be denominated the Department of War, and that there shall be a principal officer therein, to be called the Secretary for the Department of War...`,
      route: '/us/departmentofdefense',
      urlKey: 'departmentofdefense'
    },
    mainFeeds: [
      {
        id: 'defenseNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'Foreign Affairs',
        buttonName: '',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'army',
        name: 'Department of the Army',
        shortName: 'Army',
        image: '/army.svg',
        route: '/us/departmentofdefense/army',
        officialURL: 'https://www.army.mil/',
        missionStatement: 'The Army provides the ground forces necessary to defend the United States.',
        apiParams: generateAgencyApiParams('defense', 'Army Department'),
        feedName: 'Army Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Military Branches'
      },
      {
        id: 'navy',
        name: 'Department of the Navy',
        shortName: 'Navy',
        image: '/navy.svg',
        route: '/us/departmentofdefense/navy',
        officialURL: 'https://www.navy.mil/',
        missionStatement: 'The Navy provides naval forces necessary for the deterrent of war and maintenance of peace.',
        apiParams: generateAgencyApiParams('defense', 'Navy Department'),
        feedName: 'Navy Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Military Branches'
      },
      {
        id: 'air-force',
        name: 'Department of the Air Force',
        shortName: 'Air Force',
        image: '/airforce.svg',
        route: '/us/departmentofdefense/air-force',
        officialURL: 'https://www.af.mil/',
        missionStatement: 'The Air Force provides air and space forces to defend the United States.',
        apiParams: generateAgencyApiParams('defense', 'Air Force Department'),
        feedName: 'Air Force Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Military Branches'
      },
      {
        id: 'defacq',
        name: 'Defense Acquisition Regulations System',
        shortName: 'DARS',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/defacq',
        officialURL: 'http://www.acq.osd.mil/dpap/dars/index.html',
        missionStatement: 'The Defense Acquisition Regulations System (DARS) develops and maintains acquisition rules and guidance to facilitate the acquisition workforce as they acquire the goods and services DoD requires to ensure Americas warfighters continued worldwide success.',
        apiParams: generateAgencyApiParams('defense', 'Defense Acquisition Regulations System'),
        feedName: 'Defense Acquisition Regulations System Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Acquisition & Contracting'
      },
      {
        id: 'defcontract',
        name: 'Defense Contract Audit Agency',
        shortName: 'DCAA',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/defcontract',
        officialURL: 'http://www.dcaa.mil/',
        missionStatement: 'While serving the public interest as its primary customer, The DCAA performs all necessary contract audits for the Department of Defense and provides accounting and financial advisory services regarding contracts and subcontracts to all DoD Components responsible for procurement and contract administration.',
        apiParams: generateAgencyApiParams('defense', 'Defense Contract Audit Agency'),
        feedName: 'Defense Contract Audit Agency Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Acquisition & Contracting'
      },
      {
        id: 'disa',
        name: 'Defense Information Systems Agency',
        shortName: 'DISA',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/disa',
        officialURL: 'http://disa.mil/',
        missionStatement: 'DISA is a combat support agency comprised of military, federal civilian, and contractor partners.',
        apiParams: generateAgencyApiParams('defense', 'Defense Information Systems Agency'),
        feedName: 'Defense Information Systems Agency Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Information & Technology'
      },
      {
        id: 'dia',
        name: 'Defense Intelligence Agency',
        shortName: 'DIA',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/dia',
        officialURL: 'http://www.dia.mil',
        missionStatement: 'We provide military intelligence to warfighters, defense policymakers and force planners, in the Department of Defense and the Intelligence Community, in support of U.S. military planning and operations and weapon systems acquisition.',
        apiParams: generateAgencyApiParams('defense', 'Defense Intelligence Agency'),
        feedName: 'Defense Intelligence Agency Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Intelligence & Security'
      },
      {
        id: 'dla',
        name: 'Defense Logistics Agency',
        shortName: 'DLA',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/dla',
        officialURL: 'http://www.dla.mil/Pages/default.aspx',
        missionStatement: 'DLA supports both the logistics requirements of the military services and their acquisition of weapons and other materiel. The Agency provides logistics support and technical services to all branches of the military and to a number of Federal agencies.',
        apiParams: generateAgencyApiParams('defense', 'Defense Logistics Agency'),
        feedName: 'Defense Logistics Agency Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Logistics & Support'
      },
      {
        id: 'engineerscorps',
        name: 'Engineers Corps',
        shortName: 'USACE',
        image: '/engineersCorps.png',
        route: '/us/departmentofdefense/engineerscorps',
        officialURL: 'http://www.usace.army.mil/Pages/default.aspx',
        missionStatement: 'To deliver vital public and military engineering services; partnering in peace and war to strengthen our nations security, energize the economy and reduce risks from disasters.',
        apiParams: generateAgencyApiParams('defense', 'Engineers Corps'),
        feedName: 'Engineers Corps Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Engineering & Construction'
      },
      {
        id: 'ngia',
        name: 'National Geospatial-Intelligence Agency',
        shortName: 'NGA',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/ngia',
        officialURL: 'https://www.nga.mil/',
        missionStatement: 'The National Geospatial-Intelligence Agency is the nation\'s primary source of geospatial intelligence for the Department of Defense and the U.S. Intelligence Community.',
        apiParams: generateAgencyApiParams('defense', 'National Geospatial-Intelligence Agency'),
        feedName: 'National Geospatial-Intelligence Agency Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Intelligence & Security'
      },
      {
        id: 'nsa',
        name: 'National Security Agency',
        shortName: 'NSA',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/nsa',
        officialURL: 'http://www.nsa.gov/',
        missionStatement: 'As the Nations cryptologic organization, NSA/CSS employs the Nations premier codemakers and codebreakers. It ensures an informed, alert, and secure environment for U.S. warfighters and policymakers.',
        apiParams: generateAgencyApiParams('defense', 'National Security Agency/Central Security Service'),
        feedName: 'National Security Agency Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Intelligence & Security'
      },
      {
        id: 'uniformedservices',
        name: 'Uniformed Services University of the Health Sciences',
        shortName: 'USUHS',
        image: '/departmentOfDefense.png',
        route: '/us/departmentofdefense/uniformedservices',
        officialURL: 'http://www.usuhs.mil/',
        missionStatement: 'Authorized by act of September 21, 1972 (10 U.S.C. 2112), the Uniformed Services University of the Health Sciences was established to educate career-oriented medical officers for the Military Departments and the Public Health Service.',
        apiParams: generateAgencyApiParams('defense', 'Uniformed Services University of the Health Sciences'),
        feedName: 'Uniformed Services University of the Health Sciences Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Education & Training'
      }
    ]
  },

  commerce: {
    departmentInfo: {
      name: 'Department of Commerce',
      image: '/departmentOfCommerce.png',
      officialURL: 'https://www.commerce.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-32/pdf/STATUTE-32-Pt1-Pg825.pdf',
      missionStatement: 'The Department of Commerce promotes economic growth, job creation, and sustainable development.',
      establishingActText: 'An Act to establish a Department of Commerce and Labor...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there shall be at the seat of government an executive department to be known as the Department of Commerce and Labor...`,
      route: '/us/departmentofcommerce',
      urlKey: 'departmentofcommerce'
    },
    mainFeeds: [
      {
        id: 'commerceNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=commerce&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'Commerce',
        buttonName: '',
        type: 'main'
      },
      {
        id: 'commerceDocs',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=commerce&order_by=created_at&filter_column=agency&filter_string=Commerce%20Department',
        feedBranch: 'Executive',
        feedTopic: 'Commerce',
        buttonName: '',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'censusburea',
        name: 'Census Bureau',
        shortName: 'Census',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/censusburea',
        officialURL: 'http://www.census.gov/',
        missionStatement: 'The Census Bureau is responsible for the the decennial censuses of population and housing; the quinquennial censuses of State and local governments, manufacturers, mineral industries, distributive trades, construction industries, and transportation.',
        apiParams: generateAgencyApiParams('commerce', 'Census Bureau'),
        feedName: 'Census Bureau Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Statistics & Data'
      },
      {
        id: 'economic-analysis-bureau',
        name: 'Economic Analysis Bureau',
        shortName: 'BEA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/economic-analysis-bureau',
        officialURL: 'https://www.bea.gov/',
        missionStatement: 'BEA produces economic accounts statistics that enable government and business decision-makers, researchers, and the American public to follow and understand the performance of the Nation\'s economy.',
        apiParams: generateAgencyApiParams('commerce', 'Economic Analysis Bureau'),
        feedName: 'Economic Analysis Bureau Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Economic Analysis'
      },
      {
        id: 'economic-development',
        name: 'Economic Development Administration',
        shortName: 'EDA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/economic-development',
        officialURL: 'https://www.eda.gov/',
        missionStatement: 'EDA\'s mission is to lead the federal economic development agenda by promoting innovation and competitiveness, preparing American regions for growth and success in the worldwide economy.',
        apiParams: generateAgencyApiParams('commerce', 'Economic Development Administration'),
        feedName: 'Economic Development Administration Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Economic Development'
      },
      {
        id: 'economics-statistics',
        name: 'Economics and Statistics Administration',
        shortName: 'ESA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/economics-statistics',
        officialURL: 'https://www.esa.gov/',
        missionStatement: 'ESA provides timely economic analysis, disseminates national economic indicators, and oversees the U.S. Census Bureau and the Bureau of Economic Analysis.',
        apiParams: generateAgencyApiParams('commerce', 'Economics and Statistics Administration'),
        feedName: 'Economics and Statistics Administration Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Statistics & Data'
      },
      {
        id: 'export-administration',
        name: 'Export Administration Bureau',
        shortName: 'BIS',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/export-administration',
        officialURL: 'https://www.bis.doc.gov/',
        missionStatement: 'The Bureau of Industry and Security (BIS) advances U.S. national security, foreign policy, and economic objectives by ensuring an effective export control and treaty compliance system and promoting continued U.S. strategic technology leadership.',
        apiParams: generateAgencyApiParams('commerce', 'Export Administration Bureau'),
        feedName: 'Export Administration Bureau Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Trade & Export Control'
      },
      {
        id: 'foreign-trade-zones',
        name: 'Foreign-Trade Zones Board',
        shortName: 'FTZ Board',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/foreign-trade-zones',
        officialURL: 'https://enforcement.trade.gov/ftzpage/',
        missionStatement: 'The FTZ Board provides communities with the authority to designate areas where companies can use special procedures to encourage U.S. activity and value added — in competition with foreign alternatives — by reducing, eliminating, or delaying duties on imports.',
        apiParams: generateAgencyApiParams('commerce', 'Foreign-Trade Zones Board'),
        feedName: 'Foreign-Trade Zones Board Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Trade & Export Control'
      },
      {
        id: 'industry-security',
        name: 'Industry and Security Bureau',
        shortName: 'BIS',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/industry-security',
        officialURL: 'https://www.bis.doc.gov/',
        missionStatement: 'BIS advances U.S. national security, foreign policy, and economic objectives by ensuring an effective export control and treaty compliance system and promoting continued U.S. strategic technology leadership.',
        apiParams: generateAgencyApiParams('commerce', 'Industry and Security Bureau'),
        feedName: 'Industry and Security Bureau Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Trade & Export Control'
      },

      {
        id: 'minority-business',
        name: 'Minority Business Development Agency',
        shortName: 'MBDA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/minority-business',
        officialURL: 'https://www.mbda.gov/',
        missionStatement: 'MBDA promotes the growth of minority-owned businesses through the mobilization and advancement of public and private sector programs, policy, and research.',
        apiParams: generateAgencyApiParams('commerce', 'Minority Business Development Agency'),
        feedName: 'Minority Business Development Agency Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Business Development'
      },
      {
        id: 'nist',
        name: 'National Institute of Standards and Technology',
        shortName: 'NIST',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/nist',
        officialURL: 'https://www.nist.gov/',
        missionStatement: 'NIST promotes U.S. innovation and industrial competitiveness by advancing measurement science, standards, and technology.',
        apiParams: generateAgencyApiParams('commerce', 'National Institute of Standards and Technology'),
        feedName: 'National Institute of Standards and Technology Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Standards & Technology'
      },
      {
        id: 'noaa',
        name: 'National Oceanic and Atmospheric Administration',
        shortName: 'NOAA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/noaa',
        officialURL: 'https://www.noaa.gov/',
        missionStatement: 'NOAA enriches life through science. It provides actionable information about the oceans, atmosphere, and marine resources.',
        apiParams: generateAgencyApiParams('commerce', 'National Oceanic and Atmospheric Administration'),
        feedName: 'National Oceanic and Atmospheric Administration Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Science & Environment'
      },
      {
        id: 'ntis',
        name: 'National Technical Information Service',
        shortName: 'NTIS',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/ntis',
        officialURL: 'https://www.ntis.gov/',
        missionStatement: 'NTIS helps federal agencies make better decisions about data, with innovative approaches to data, including data science, data interoperability, data analytics, and data dissemination.',
        apiParams: generateAgencyApiParams('commerce', 'National Technical Information Service'),
        feedName: 'National Technical Information Service Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Information Services'
      },
      {
        id: 'ntia',
        name: 'National Telecommunications and Information Administration',
        shortName: 'NTIA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/ntia',
        officialURL: 'https://www.ntia.doc.gov/',
        missionStatement: 'NTIA is the Executive Branch agency that is principally responsible for advising the President on telecommunications and information policy issues.',
        apiParams: generateAgencyApiParams('commerce', 'National Telecommunications and Information Administration'),
        feedName: 'National Telecommunications and Information Administration Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Telecommunications'
      },
      {
        id: 'patent-trademark',
        name: 'Patent and Trademark Office',
        shortName: 'USPTO',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/patent-trademark',
        officialURL: 'https://www.uspto.gov/',
        missionStatement: 'The USPTO is responsible for granting U.S. patents and registering trademarks. It advances the nation\'s progress in innovation and industrial productivity.',
        apiParams: generateAgencyApiParams('commerce', 'Patent and Trademark Office'),
        feedName: 'Patent and Trademark Office Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Intellectual Property'
      },
      {
        id: 'technology-administration',
        name: 'Technology Administration',
        shortName: 'TA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/technology-administration',
        officialURL: 'https://www.nist.gov/',
        missionStatement: 'The Technology Administration promotes technological innovation and advancement in the United States.',
        apiParams: generateAgencyApiParams('commerce', 'Technology Administration'),
        feedName: 'Technology Administration Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Standards & Technology'
      },
      {
        id: 'travel-tourism',
        name: 'Travel and Tourism Administration',
        shortName: 'TTA',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/travel-tourism',
        officialURL: 'https://www.trade.gov/industry-information/us-travel-and-tourism-advisory-board',
        missionStatement: 'The Travel and Tourism Administration promotes the United States as a premier travel destination and provides policy recommendations on the travel industry.',
        apiParams: generateAgencyApiParams('commerce', 'Travel and Tourism Administration'),
        feedName: 'Travel and Tourism Administration Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Tourism & Trade'
      },
      {
        id: 'economic-affairs',
        name: 'Under-Secretary for Economic Affairs',
        shortName: 'Economic Affairs',
        image: '/departmentOfCommerce.png',
        route: '/us/departmentofcommerce/economic-affairs',
        officialURL: 'https://www.commerce.gov/',
        missionStatement: 'The Under-Secretary for Economic Affairs advises on economic policy and provides data analysis and insights to foster economic growth and opportunity.',
        apiParams: generateAgencyApiParams('commerce', 'Under-Secretary for Economic Affairs'),
        feedName: 'Under-Secretary for Economic Affairs Documents',
        topic: 'Commerce',
        buttonName: 'Document',
        category: 'Economic Analysis'
      }
    ]
  },
  health: {
    departmentInfo: {
      name: 'Department of Health and Human Services',
      image: '/departmentOfHealth.png',
      officialURL: 'https://www.hhs.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-67/pdf/STATUTE-67-Pg631.pdf',
      missionStatement: 'The mission of HHS is to enhance the health and well-being of all Americans, by providing for effective health and human services and by fostering sound, sustained advances in the sciences underlying medicine, public health, and social services.',
      establishingActText: 'An Act to establish a Department of Health and Human Services...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there is hereby established an executive department of the Government to be known as the Department of Health and Human Services...`,
      route: '/us/departmentofhealth',
      urlKey: 'departmentofhealth'
    },
    mainFeeds: [
      {
        id: 'healthNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=health_and_human_services&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'Health',
        buttonName: '',
        type: 'main'
      },
      {
        id: 'healthDocs',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=health_and_human_services&order_by=created_at&filter_column=agency&filter_string=Health%20and%20Human%20Services%20Department',
        feedBranch: 'Executive',
        feedTopic: 'Health',
        buttonName: '',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'healthcare',
        name: 'Agency for Healthcare Research and Quality',
        shortName: 'AHRQ',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/healthcare',
        officialURL: 'http://www.ahrq.gov/about/ahrqfact.htm',
        missionStatement: 'AHRQ is the health services research arm of the U.S. Department of Health and Human Services (HHS).',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Agency for Healthcare Research and Quality'),
        feedName: 'Agency for Healthcare Research and Quality Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Research & Quality'
      },
      {
        id: 'toxic-substances',
        name: 'Agency for Toxic Substances and Disease Registry',
        shortName: 'ATSDR',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/toxic-substances',
        officialURL: 'https://www.atsdr.cdc.gov/',
        missionStatement: 'ATSDR protects communities from harmful health effects related to exposure to natural and man-made hazardous substances.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Agency for Toxic Substances and Disease Registry'),
        feedName: 'Agency for Toxic Substances and Disease Registry Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Public Health & Safety'
      },
      {
        id: 'aging-administration',
        name: 'Aging Administration',
        shortName: 'AOA',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/aging-administration',
        officialURL: 'https://acl.gov/',
        missionStatement: 'The Administration for Community Living (ACL) provides funding and support to programs that serve older adults and people with disabilities.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Aging Administration'),
        feedName: 'Aging Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Community Services'
      },
      {
        id: 'cdc',
        name: 'Centers for Disease Control and Prevention',
        shortName: 'CDC',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/cdc',
        officialURL: 'https://www.cdc.gov/',
        missionStatement: 'CDC works 24/7 to protect America from health, safety, and security threats, both foreign and domestic.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Centers for Disease Control and Prevention'),
        feedName: 'Centers for Disease Control and Prevention Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Public Health & Safety'
      },
      {
        id: 'medicare-medicaid',
        name: 'Centers for Medicare & Medicaid Services',
        shortName: 'CMS',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/medicare-medicaid',
        officialURL: 'https://www.cms.gov/',
        missionStatement: 'CMS administers the nation\'s major healthcare programs including Medicare, Medicaid, and the Children\'s Health Insurance Program (CHIP).',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Centers for Medicare & Medicaid Services'),
        feedName: 'Centers for Medicare & Medicaid Services Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Healthcare Programs'
      },
      {
        id: 'child-support',
        name: 'Child Support Enforcement Office',
        shortName: 'OCSE',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/child-support',
        officialURL: 'https://www.acf.hhs.gov/css',
        missionStatement: 'OCSE oversees the national child support program, which touches the lives of about one in five children.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Child Support Enforcement Office'),
        feedName: 'Child Support Enforcement Office Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Family Services'
      },
      {
        id: 'children-families',
        name: 'Children and Families Administration',
        shortName: 'ACF',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/children-families',
        officialURL: 'https://www.acf.hhs.gov/',
        missionStatement: 'ACF promotes the economic and social well-being of families, children, individuals, and communities.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Children and Families Administration'),
        feedName: 'Children and Families Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Family Services'
      },
      {
        id: 'community-living',
        name: 'Community Living Administration',
        shortName: 'ACL',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/community-living',
        officialURL: 'https://acl.gov/',
        missionStatement: 'The Administration for Community Living (ACL) helps older adults and people with disabilities live independently and participate fully in their communities.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Community Living Administration'),
        feedName: 'Community Living Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Community Services'
      },
      {
        id: 'fda',
        name: 'Food and Drug Administration',
        shortName: 'FDA',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/fda',
        officialURL: 'https://www.fda.gov/',
        missionStatement: 'FDA protects the public health by ensuring the safety, efficacy, and security of human and veterinary drugs, biological products, and medical devices.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Food and Drug Administration'),
        feedName: 'Food and Drug Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Regulatory & Safety'
      },
      {
        id: 'health-care-finance',
        name: 'Health Care Finance Administration',
        shortName: 'HCFA',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/health-care-finance',
        officialURL: 'https://www.cms.gov/',
        missionStatement: 'HCFA oversees Medicare and Medicaid programs to provide healthcare to eligible Americans.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Health Care Finance Administration'),
        feedName: 'Health Care Finance Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Healthcare Programs'
      },
      {
        id: 'health-resources',
        name: 'Health Resources and Services Administration',
        shortName: 'HRSA',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/health-resources',
        officialURL: 'https://www.hrsa.gov/',
        missionStatement: 'HRSA provides healthcare to people who are geographically isolated and economically or medically vulnerable.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Health Resources and Services Administration'),
        feedName: 'Health Resources and Services Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Healthcare Services'
      },
      {
        id: 'indian-health',
        name: 'Indian Health Service',
        shortName: 'IHS',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/indian-health',
        officialURL: 'https://www.ihs.gov/',
        missionStatement: 'IHS provides healthcare services to American Indians and Alaska Natives.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Indian Health Service'),
        feedName: 'Indian Health Service Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Healthcare Services'
      },
      {
        id: 'nih',
        name: 'National Institutes of Health',
        shortName: 'NIH',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/nih',
        officialURL: 'https://www.nih.gov/',
        missionStatement: 'NIH is the primary agency of the U.S. government responsible for biomedical and public health research.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'National Institutes of Health'),
        feedName: 'National Institutes of Health Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Research & Quality'
      },
      {
        id: 'national-library-medicine',
        name: 'National Library of Medicine',
        shortName: 'NLM',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/national-library-medicine',
        officialURL: 'https://www.nlm.nih.gov/',
        missionStatement: 'NLM is the world\'s largest biomedical library and a leader in research in computational health sciences.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'National Library of Medicine'),
        feedName: 'National Library of Medicine Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Research & Quality'
      },
      {
        id: 'program-support-center',
        name: 'Program Support Center',
        shortName: 'PSC',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/program-support-center',
        officialURL: 'https://psc.gov/',
        missionStatement: 'PSC provides a range of shared services to support the administrative needs of HHS and other federal agencies.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Program Support Center'),
        feedName: 'Program Support Center Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Administrative Support'
      },
      {
        id: 'public-health-service',
        name: 'Public Health Service',
        shortName: 'PHS',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/public-health-service',
        officialURL: 'https://www.usphs.gov/',
        missionStatement: 'PHS is responsible for protecting, promoting, and advancing the health and safety of the nation.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Public Health Service'),
        feedName: 'Public Health Service Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Public Health & Safety'
      },
      {
        id: 'refugee-resettlement',
        name: 'Refugee Resettlement Office',
        shortName: 'ORR',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/refugee-resettlement',
        officialURL: 'https://www.acf.hhs.gov/orr',
        missionStatement: 'ORR provides new populations with the opportunity to maximize their potential in the United States.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Refugee Resettlement Office'),
        feedName: 'Refugee Resettlement Office Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Community Services'
      },
      {
        id: 'strategic-preparedness',
        name: 'Strategic Preparedness and Response Administration',
        shortName: 'ASPR',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/strategic-preparedness',
        officialURL: 'https://www.hhs.gov/about/agencies/aspr/index.html',
        missionStatement: 'ASPR leads the nation\'s medical and public health preparedness for, response to, and recovery from disasters and public health emergencies.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Strategic Preparedness and Response Administration'),
        feedName: 'Strategic Preparedness and Response Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Emergency Preparedness'
      },
      {
        id: 'substance-abuse',
        name: 'Substance Abuse and Mental Health Services Administration',
        shortName: 'SAMHSA',
        image: '/departmentOfHealth.png',
        route: '/us/departmentofhealth/substance-abuse',
        officialURL: 'https://www.samhsa.gov/',
        missionStatement: 'SAMHSA leads public health efforts to advance the behavioral health of the nation.',
        apiParams: generateAgencyApiParams('health_and_human_services', 'Substance Abuse and Mental Health Services Administration'),
        feedName: 'Substance Abuse and Mental Health Services Administration Documents',
        topic: 'Health',
        buttonName: 'Document',
        category: 'Mental Health & Substance Abuse'
      }
    ]
  },

  housing: {
    departmentInfo: {
      name: 'Department of Housing and Urban Development',
      image: '/departmentOfHousing.png',
      officialURL: 'https://www.hud.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-79/pdf/STATUTE-79-Pg667.pdf',
      missionStatement: 'HUD\'s mission is to create strong, sustainable, inclusive communities and quality affordable homes for all.',
      establishingActText: 'An Act to provide for the establishment of a Department of Housing and Urban Development...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there is hereby established at the seat of the Government of the United States an executive department to be known as the Department of Housing and Urban Development...`,
      route: '/us/departmentofhousing',
      urlKey: 'departmentofhousing'
    },
    mainFeeds: [
      {
        id: 'housingNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=housing_and_urban_development&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'Housing',
        buttonName: '',
        type: 'main'
      },
      {
        id: 'housingDocs',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=housing_and_urban_development&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20Housing%20And%20Urban%20Development%20Documents',
        feedBranch: 'Executive',
        feedTopic: 'Housing',
        buttonName: '',
        type: 'main'
      }
    ],
    agencies: [
    
    ]
  },
  education: {
    departmentInfo: {
      name: 'Department of Education',
      image: '/departmentOfEducation.png',
      officialURL: 'https://www.ed.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-93/pdf/STATUTE-93-Pg668.pdf',
      missionStatement: 'The Department of Education promotes student achievement and preparation for global competitiveness by fostering educational excellence and ensuring equal access.',
      establishingActText: 'An Act to establish a Department of Education...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there is established an executive department of the Government of the United States to be known as the Department of Education...`,
      route: '/us/departmentofeducation',
      urlKey: 'departmentofeducation'
    },
    mainFeeds: [
      {
        id: 'educationNews',
        name: 'Department of Education',
        apiParams: '&skip=0&schema=united_states_of_america&table=education&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20Education%20Press%20Release',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      },
      {
        id: 'educationDocuments',
        name: 'Department of Education Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=education&order_by=created_at&filter_column=agency&filter_string=Education%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Documents',
        type: 'main'
      }
    ],
    agencies: [
  
    ]
  },
  energy: {
    departmentInfo: {
      name: 'Department of Energy',
      image: '/departmentOfEnergy.png',
      officialURL: 'https://www.energy.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-91/pdf/STATUTE-91-Pg565.pdf',
      missionStatement: 'The mission of the Energy Department is to ensure America\'s security and prosperity by addressing its energy, environmental and nuclear challenges through transformative science and technology solutions.',
      establishingActText: 'An Act to establish a Department of Energy...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there is hereby established at the seat of the Government of the United States an executive department to be known as the Department of Energy...`,
      route: '/us/departmentofenergy',
      urlKey: 'departmentofenergy'
    },
    mainFeeds: [
      {
        id: 'energyNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=energy&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      },
      {
        id: 'energyDocuments',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=energy&order_by=created_at&filter_column=agency&filter_string=Energy%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'energy-efficiency-renewable',
        name: 'Office of Energy Efficiency and Renewable Energy',
        shortName: 'EERE',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/energy-efficiency-renewable',
        officialURL: 'https://www.energy.gov/eere',
        missionStatement: 'EERE accelerates the research, development, demonstration, and deployment of technologies and solutions to equitably transition America to net-zero greenhouse gas emissions economy-wide by no later than 2050.',
        apiParams: generateAgencyApiParams('energy', 'Energy Efficiency and Renewable Energy Office'),
        feedName: 'Office of Energy Efficiency and Renewable Energy Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Energy Efficiency'
      },
      {
        id: 'energy-information',
        name: 'Energy Information Administration',
        shortName: 'EIA',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/energy-information',
        officialURL: 'https://www.eia.gov/',
        missionStatement: 'EIA collects, analyzes, and disseminates independent and impartial energy information to promote sound policymaking, efficient markets, and public understanding of energy and its interaction with the economy and the environment.',
        apiParams: generateAgencyApiParams('energy', 'Energy Information Administration'),
        feedName: 'Energy Information Administration Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Energy Data & Analysis'
      },
      {
        id: 'ferc',
        name: 'Federal Energy Regulatory Commission',
        shortName: 'FERC',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/ferc',
        officialURL: 'https://www.ferc.gov/',
        missionStatement: 'FERC regulates the interstate transmission of electricity, natural gas, and oil. FERC also reviews proposals to build liquefied natural gas terminals and interstate natural gas pipelines as well as licensing hydropower projects.',
        apiParams: generateAgencyApiParams('energy', 'Federal Energy Regulatory Commission'),
        feedName: 'Federal Energy Regulatory Commission Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Energy Regulation'
      },
      {
        id: 'nnsa',
        name: 'National Nuclear Security Administration',
        shortName: 'NNSA',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/nnsa',
        officialURL: 'https://www.energy.gov/nnsa',
        missionStatement: 'NNSA maintains and enhances the safety, security, and effectiveness of the U.S. nuclear weapons stockpile.',
        apiParams: generateAgencyApiParams('energy', 'National Nuclear Security Administration'),
        feedName: 'National Nuclear Security Administration Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Nuclear Security'
      },
      {
        id: 'bonneville-power',
        name: 'Bonneville Power Administration',
        shortName: 'BPA',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/bonneville-power',
        officialURL: 'https://www.bpa.gov/',
        missionStatement: 'BPA markets wholesale electrical power from 31 federal hydroelectric projects in the Columbia River Basin, one nonfederal nuclear plant and several small nonfederal power plants.',
        apiParams: generateAgencyApiParams('energy', 'Bonneville Power Administration'),
        feedName: 'Bonneville Power Administration Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Power Marketing'
      },
      {
        id: 'southeastern-power',
        name: 'Southeastern Power Administration',
        shortName: 'SEPA',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/southeastern-power',
        officialURL: 'https://www.energy.gov/sepa',
        missionStatement: 'SEPA markets electric power and energy generated at multipurpose water resource projects under the control of the U.S. Army Corps of Engineers.',
        apiParams: generateAgencyApiParams('energy', 'Southeastern Power Administration'),
        feedName: 'Southeastern Power Administration Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Power Marketing'
      },
      {
        id: 'southwestern-power',
        name: 'Southwestern Power Administration',
        shortName: 'SWPA',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/southwestern-power',
        officialURL: 'https://www.energy.gov/swpa',
        missionStatement: 'SWPA markets hydroelectric power generated by the U.S. Army Corps of Engineers at 24 multipurpose dams in the states of Arkansas, Kansas, Louisiana, Missouri, Oklahoma, and Texas.',
        apiParams: generateAgencyApiParams('energy', 'Southwestern Power Administration'),
        feedName: 'Southwestern Power Administration Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Power Marketing'
      },
      {
        id: 'western-power',
        name: 'Western Area Power Administration',
        shortName: 'WAPA',
        image: '/departmentOfEnergy.png',
        route: '/us/departmentofenergy/western-power',
        officialURL: 'https://www.wapa.gov/',
        missionStatement: 'WAPA markets and delivers reliable, renewable, federal hydroelectric power and related services.',
        apiParams: generateAgencyApiParams('energy', 'Western Area Power Administration'),
        feedName: 'Western Area Power Administration Documents',
        topic: 'Energy',
        buttonName: 'Document',
        category: 'Power Marketing'
      }
    ]
  },
  veterans: {
    departmentInfo: {
      name: 'Department of Veterans Affairs',
      image: '/departmentOfVeterans.png',
      officialURL: 'https://www.va.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/STATUTE-102/pdf/STATUTE-102-Pg2635.pdf',
      missionStatement: 'To fulfill President Lincoln\'s promise "To care for him who shall have borne the battle, and for his widow, and his orphan" by serving and honoring the men and women who are America\'s veterans.',
      establishingActText: 'An Act to establish a Department of Veterans Affairs...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That there is hereby established an executive department to be known as the Department of Veterans Affairs...`,
      route: '/us/departmentofveteransaffairs',
      urlKey: 'departmentofveteransaffairs'
    },
    mainFeeds: [
      {
        id: 'veteransAffairsNews',
        name: 'News',
        apiParams: '&skip=0&schema=united_states_of_america&table=veterans_affairs_news&order_by=created_at',
        feedBranch: 'Executive',
        feedTopic: '',
        buttonName: 'Document',
        type: 'main'
      },
      {
        id: 'veteransAffairsDocuments',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=veterans_affairs_news&order_by=created_at&filter_column=agency&filter_string=Veterans%20Affairs%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      }
    ],
    agencies: []
  },homeland: {
    departmentInfo: {
      name: 'Department of Homeland Security',
      image: '/departmentOfHomeland.png',
      officialURL: 'https://www.dhs.gov/',
      establishingActURL: 'https://www.govinfo.gov/content/pkg/PLAW-107publ296/pdf/PLAW-107publ296.pdf',
      missionStatement: 'With honor and integrity, we will safeguard the American people, our homeland, and our values.',
      establishingActText: 'An Act to establish the Department of Homeland Security...',
      fullEstablishingAct: `Be it enacted by the Senate and House of Representatives of the United States of America in Congress assembled, That this Act may be cited as the "Homeland Security Act of 2002". There is established a Department of Homeland Security...`,
      route: '/us/departmentofhomeland',
      urlKey: 'departmentofhomeland'
    },
    mainFeeds: [
      {
        id: 'homelandSecurityDocuments',
        name: 'Documents',
        apiParams: '&skip=0&schema=united_states_of_america&table=homeland_security&order_by=created_at&filter_column=agency&filter_string=Homeland%20Security%20Department',
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document',
        type: 'main'
      }
    ],
    agencies: [
      {
        id: 'coast-guard',
        name: 'U.S. Coast Guard',
        shortName: 'USCG',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/coast-guard',
        officialURL: 'https://www.uscg.mil/',
        missionStatement: 'The U.S. Coast Guard saves lives, protects the environment, defends our maritime borders, and supports the economic security of the United States.',
        apiParams: generateAgencyApiParams('homeland_security', 'Coast Guard'),
        feedName: 'U.S. Coast Guard Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Maritime Security'
      },
      {
        id: 'fema',
        name: 'Federal Emergency Management Agency',
        shortName: 'FEMA',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/fema',
        officialURL: 'https://www.fema.gov/',
        missionStatement: 'FEMA helps people before, during, and after disasters.',
        apiParams: generateAgencyApiParams('homeland_security', 'Federal Emergency Management Agency'),
        feedName: 'Federal Emergency Management Agency Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Emergency Management'
      },
      {
        id: 'fletc',
        name: 'Federal Law Enforcement Training Center',
        shortName: 'FLETC',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/fletc',
        officialURL: 'https://www.fletc.gov/',
        missionStatement: 'FLETC serves as an interagency law enforcement training organization for 91 federal agencies.',
        apiParams: generateAgencyApiParams('homeland_security', 'Federal Law Enforcement Training Center'),
        feedName: 'Federal Law Enforcement Training Center Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Law Enforcement Training'
      },
      {
        id: 'secret-service',
        name: 'U.S. Secret Service',
        shortName: 'USSS',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/secret-service',
        officialURL: 'https://www.secretservice.gov/',
        missionStatement: 'The Secret Service protects our nation\'s leaders and financial infrastructure.',
        apiParams: generateAgencyApiParams('homeland_security', 'Secret Service'),
        feedName: 'U.S. Secret Service Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Protection Services'
      },
      {
        id: 'tsa',
        name: 'Transportation Security Administration',
        shortName: 'TSA',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/tsa',
        officialURL: 'https://www.tsa.gov/',
        missionStatement: 'TSA protects the nation\'s transportation systems to ensure freedom of movement for people and commerce.',
        apiParams: generateAgencyApiParams('homeland_security', 'Transportation Security Administration'),
        feedName: 'Transportation Security Administration Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Transportation Security'
      },
      {
        id: 'uscis',
        name: 'U.S. Citizenship and Immigration Services',
        shortName: 'USCIS',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/uscis',
        officialURL: 'https://www.uscis.gov/',
        missionStatement: 'USCIS administers the nation\'s lawful immigration system, safeguarding its integrity and promise by efficiently and fairly adjudicating requests for immigration benefits.',
        apiParams: generateAgencyApiParams('homeland_security', 'U.S. Citizenship and Immigration Services'),
        feedName: 'U.S. Citizenship and Immigration Services Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Immigration Services'
      },
      {
        id: 'cbp',
        name: 'U.S. Customs and Border Protection',
        shortName: 'CBP',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/cbp',
        officialURL: 'https://www.cbp.gov/',
        missionStatement: 'CBP safeguards America\'s borders to protect the public from dangerous people and materials while enhancing the Nation\'s global economic competitiveness.',
        apiParams: generateAgencyApiParams('homeland_security', 'U.S. Customs and Border Protection'),
        feedName: 'U.S. Customs and Border Protection Documents',
        topic: 'Defense',
        buttonName: 'Document',
        category: 'Border Security'
      },
      {
        id: 'ice',
        name: 'U.S. Immigration and Customs Enforcement',
        shortName: 'ICE',
        image: '/departmentOfHomeland.png',
        route: '/us/departmentofhomeland/ice',
        officialURL: 'https://www.ice.gov/',
        missionStatement: 'ICE protects America from the cross-border crime and illegal immigration that threaten national security and public safety.',
        apiParams: generateAgencyApiParams('homeland_security', 'U.S. Immigration and Customs Enforcement'),
        feedName: 'U.S. Immigration and Customs Enforcement Documents',
        topic: 'Immigration',
        buttonName: 'Document',
        category: 'Immigration Enforcement'
      }
    ]
  }

};

// URL to config key mapping
const urlToConfigMapping = {
  'departmentofagriculture': 'agriculture',
  'departmentofdefense': 'defense',
  'departmentofcommerce': 'commerce',
  'departmentofjustice': 'justice',
  'departmentofhealth': 'health',
  'departmentofenergy': 'energy',
  'departmentoftransportation': 'transportation',
  'departmentoftreasury': 'treasury',
  'departmentoflabor': 'labor',
  'departmentoftheinterior': 'interior',
  'departmentofhousing': 'housing',
  'departmentofeducation': 'education',
  'departmentofhomeland': 'homeland',
  'departmentofstate': 'state',
  'departmentofveteransaffairs': 'veterans'
};

// Helper functions to work with the config
export const getDepartmentConfig = (departmentKey) => {
  // Handle URL mapping
  const configKey = urlToConfigMapping[departmentKey] || departmentKey;
  const result = departmentConfig[configKey] || null;
  // console.log(`getDepartmentConfig: ${departmentKey} -> ${configKey} -> ${result ? 'FOUND' : 'NOT FOUND'}`);
  return result;
};

export const getDepartmentAgencies = (departmentKey) => {
  const dept = getDepartmentConfig(departmentKey);
  const agencies = dept ? dept.agencies : [];
  // console.log(`getDepartmentAgencies: ${departmentKey} -> ${agencies.length} agencies`);
  return agencies;
};

export const getAgencyConfig = (departmentKey, agencyId) => {
  // console.log(`getAgencyConfig: ${departmentKey} -> ${agencyId}`);
  const agencies = getDepartmentAgencies(departmentKey);
  const agency = agencies.find(agency => agency.id === agencyId) || null;
  // console.log(`getAgencyConfig result:`, agency ? agency.name : 'NOT FOUND');
  if (agency) {
    // console.log(`getAgencyConfig apiParams:`, agency.apiParams);
  }
  return agency;
};

export const getDepartmentMainFeeds = (departmentKey) => {
  const dept = getDepartmentConfig(departmentKey);
  const mainFeeds = dept ? dept.mainFeeds : [];
  // console.log(`getDepartmentMainFeeds: ${departmentKey} -> ${mainFeeds.length} main feeds`);
  return mainFeeds;
};

export const getAgenciesByCategory = (departmentKey) => {
  const agencies = getDepartmentAgencies(departmentKey);
  const grouped = {};
  
  agencies.forEach(agency => {
    const category = agency.category || 'Other';
    if (!grouped[category]) {
      grouped[category] = [];
    }
    grouped[category].push(agency);
  });
  
  return grouped;
};

// FIXED: Enhanced transform function with better debugging
export const transformAgencyToFeed = (agency) => {
  // console.log('=== TRANSFORM FUNCTION CALLED ===');
  // console.log('Input agency:', agency.name);
  // console.log('Input agency.apiParams:', agency.apiParams);
  
  const transformed = {
    id: agency.id,
    name: agency.name, 
    displayType: 'normal', 
    apiParams: agency.apiParams, 
    feedBranch: 'Executive',
    feedTopic: agency.topic,
    buttonName: agency.buttonName || 'Document'
  };
  
  // console.log('Transformed output:', transformed);
  // console.log('Transformed apiParams:', transformed.apiParams);
  // console.log('=================================');
  return transformed;
};

// ADDED: Debug and test functions
export const testGenerateAgencyApiParams = () => {
  // console.log('=== TESTING generateAgencyApiParams ===');
  const testCases = [
    { table: 'defense', agency: 'Army Department' },
    { table: 'defense', agency: 'Navy Department' },
    { table: 'defense', agency: 'Air Force Department' }
  ];
  
  testCases.forEach(test => {
    const result = generateAgencyApiParams(test.table, test.agency);
    // console.log(`${test.agency}:`, result);
  });
  
  // console.log('=== END TEST ===');
  return testCases.map(test => ({
    input: test,
    output: generateAgencyApiParams(test.table, test.agency)
  }));
};

// ADDED: Debug department config
export const debugDepartmentConfig = (departmentKey) => {
  // console.log('=== DEBUGGING DEPARTMENT CONFIG ===');
  // console.log('Department Key:', departmentKey);
  
  const config = getDepartmentConfig(departmentKey);
  if (!config) {
    // console.log('Department not found!');
    return null;
  }
  
  // console.log('Department Info:', config.departmentInfo.name);
  // console.log('Main Feeds:', config.mainFeeds?.length || 0);
  // console.log('Agencies:', config.agencies?.length || 0);
  
  if (config.agencies) {
    config.agencies.forEach((agency, index) => {
      // console.log(`Agency ${index + 1}: ${agency.name}`);
      // console.log(`  - API Params: ${agency.apiParams}`);
      // console.log(`  - Route: ${agency.route}`);
    });
  }
  
  // console.log('=== END DEBUG ===');
  return config;
};

// ADDED: Test URL generation for agency
export const testAgencyUrlGeneration = (departmentKey, agencyId) => {
  // console.log('=== TESTING AGENCY URL GENERATION ===');
  // console.log(`Department: ${departmentKey}, Agency: ${agencyId}`);
  
  const agency = getAgencyConfig(departmentKey, agencyId);
  if (!agency) {
    // console.log('Agency not found!');
    return null;
  }
  
  // console.log('Agency found:', agency.name);
  // console.log('API Params:', agency.apiParams);
  
  // Test the transform function
  const transformed = transformAgencyToFeed(agency);
  // console.log('Transformed for mobile:', transformed);
  
  // console.log('=== END TEST ===');
  return { agency, transformed };
};

export const getMobileFeedsForSection = (feedsConfig, departmentKey) => {
  const dept = getDepartmentConfig(departmentKey);
  if (!dept) return [];
  
  return dept.mainFeeds.map(feed => ({
    id: feed.id,
    name: feed.name,
    displayType: feed.type === 'carousel' ? 'carousel' : 'normal',
    apiParams: feed.apiParams || feed.apiEndpoint,
    feedBranch: feed.feedBranch || feed.branch,
    feedTopic: feed.feedTopic || feed.topic,
    buttonName: feed.buttonName,
    // For carousel feeds, include carousel items
    ...(feed.type === 'carousel' && {
      departmentTitle: feed.departmentTitle,
      departmentLink: feed.departmentLink,
      carouselItems: feed.carouselItems
    })
  }));
};

// Additional helper functions for routing
export const getAllDepartmentIds = () => {
  return Object.keys(departmentConfig);
};

export const getAllDepartmentRoutes = () => {
  const routes = [];
  Object.keys(departmentConfig).forEach(deptKey => {
    const dept = departmentConfig[deptKey];
    routes.push(dept.departmentInfo.route);
    
    // Add agency routes
    dept.agencies.forEach(agency => {
      routes.push(agency.route);
    });
  });
  return routes;
};

export const getAllAgencyIds = (departmentKey) => {
  const agencies = getDepartmentAgencies(departmentKey);
  return agencies.map(agency => agency.id);
};

export const isDepartmentValid = (departmentKey) => {
  const configKey = urlToConfigMapping[departmentKey] || departmentKey;
  return departmentConfig.hasOwnProperty(configKey);
};

export const isAgencyValid = (departmentKey, agencyId) => {
  return getAgencyConfig(departmentKey, agencyId) !== null;
};

// Export both named and default
export default departmentConfig;